import { DOCUMENTS_ACTIONS, DOCUMENT_REVIEW_ACTIONS } from "constants/actions";

export function fetchDocumentsChecklist(case_id, type) {
    return {
        type: DOCUMENTS_ACTIONS.FETCH_DOCUMENTS_CHECKLIST,
        payload: {
            case_id,
            type
        }
    };
}
export function fetchedDocumentsChecklist(case_id, type, checklist) {
    return {
        type: DOCUMENTS_ACTIONS.FETCHED_DOCUMENTS_CHECKLIST,
        payload: {
            case_id,
            type,
            checklist // will be created in a map
        }
    };
}
export function failedFetchDocumentsChecklist(case_id, type, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_FETCH_DOCUMENTS_CHECKLIST,
        payload: {
            case_id,
            type
        },
        error
    };
}

export function fetchCaseDocuments(case_id , companyId , kycDocAssociate = false) {
    return {
        type: DOCUMENTS_ACTIONS.FETCH_CASE_DOCUMENTS,
        payload: {
            case_id,
            kycDocAssociate
        }
    };
}
export function fetchedCaseDocuments(case_id, documents) {
    return {
        type: DOCUMENTS_ACTIONS.FETCHED_CASE_DOCUMENTS,
        payload: {
            case_id,
            documents
        }
    };
}
export function failedFetchCaseDocuments(case_id, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_FETCH_CASE_DOCUMENTS,
        payload: {
            case_id
        },
        error
    };
}

export function fetchCompanyDocuments(case_id, company_id) {
    return {
        type: DOCUMENTS_ACTIONS.FETCH_COMPANY_DOCUMENTS,
        payload: {
            case_id,
            company_id
        }
    };
}
export function fetchedCompanyDocuments(case_id, company_id, documents) {
    return {
        type: DOCUMENTS_ACTIONS.FETCHED_COMPANY_DOCUMENTS,
        payload: {
            case_id,
            company_id,
            documents
        }
    };
}
export function failedFetchCompanyDocuments(case_id, company_id, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_FETCH_COMPANY_DOCUMENTS,
        payload: {
            case_id,
            company_id
        },
        error
    };
}

export function uploadDocuments(case_id, company_id, documents) {
    return {
        type: DOCUMENTS_ACTIONS.UPLOAD_DOCUMENTS,
        payload: {
            case_id,
            company_id,
            documents
        }
    };
}
export function uploadedDocuments(case_id, company_id, documentsStatus) {
    return {
        type: DOCUMENTS_ACTIONS.UPLOADED_DOCUMENTS,
        payload: {
            case_id,
            company_id,
            documentsStatus
        }
    };
}
export function failedUploadDocuments(case_id, company_id, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_UPLOAD_DOCUMENTS,
        payload: {
            case_id,
            company_id
        },
        error
    };
}

export function uploadDocument(case_id, company_id, document) {
    return {
        type: DOCUMENTS_ACTIONS.UPLOAD_DOCUMENT,
        payload: {
            case_id,
            company_id,
            document
        }
    };
}
export function uploadedDocument(case_id, company_id, document) {
    return {
        type: DOCUMENTS_ACTIONS.UPLOADED_DOCUMENT,
        payload: {
            case_id,
            company_id,
            document
        }
    };
}
export function failedUploadDocument(case_id, company_id, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_UPLOAD_DOCUMENT,
        payload: {
            case_id,
            company_id
        },
        error
    };
}

export function attachDocument(type, case_id, doc ,{validateFromCompany = null, refresh_page = true} = {} ) {
    return {
        type: DOCUMENTS_ACTIONS.ATTACH_DOCUMENTS,
        payload: {
            type,
            case_id,
            doc,
            validateFromCompany,
            refresh_page
        }
    };
}
export function attachedDocument(type, case_id, doc) {
    return {
        type: DOCUMENTS_ACTIONS.ATTACHED_DOCUMENTS,
        payload: {
            type,
            case_id,
            doc
        }
    };
}
export function failedAttachDocument(type, case_id, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_ATTACH_DOCUMENTS,
        payload: {
            type,
            case_id
        },
        error
    };
}

export function updateDocument(case_id, company_id, docId, doc) {
    return {
        type: DOCUMENTS_ACTIONS.UPDATE_DOCUMENTS,
        payload: {
            case_id,
            company_id,
            docId,
            doc
        }
    };
}
export function updatedDocument(case_id, company_id, docId) {
    return {
        type: DOCUMENTS_ACTIONS.UPDATED_DOCUMENTS,
        payload: {
            case_id,
            company_id,
            docId
        }
    };
}
export function failedUpdateDocument(case_id, company_id, docId, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_UPDATE_DOCUMENTS,
        payload: {
            case_id,
            company_id,
            docId
        },
        error
    };
}


export function validateDocument(company_id, case_id, file, associate, address, bankAccount , {validateFromCompany = null}={}) {
    return {
        type: DOCUMENTS_ACTIONS.VALIDATE_DOCUMENT,
        payload: {
            company_id,
            case_id,
            file,
            associate,
            address,
            bankAccount,
            validateFromCompany
        }
    };
}

export function validatedDocument(company_id, case_id, file) {
    return {
        type: DOCUMENTS_ACTIONS.VALIDATED_DOCUMENT,
        payload: {
            company_id,
            case_id,
            file,
        }
    };
}
export function validatedDocumentApproval() {
    return {
        type: DOCUMENTS_ACTIONS.VALIDATED_DOCUMENT_APPROVAL ,
    };
}

export function failedValidateDocument(company_id, case_id, file, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_VALIDATE_DOCUMENT,
        payload: {
            company_id,
            case_id,
            file,
        },
        error
    };
}

export function invalidateDocument(company_id, case_id, file) {
    return {
        type: DOCUMENTS_ACTIONS.INVALIDATE_DOCUMENT,
        payload: {
            company_id,
            case_id,
            file
        }
    };
}

export function invalidatedDocumentStatus() {
    return {
        type: DOCUMENTS_ACTIONS.INVALIDATED_DOCUMENT_STATUS,
    };
}
export function invalidatedDocument(company_id, case_id, file) {
    return {
        type: DOCUMENTS_ACTIONS.INVALIDATED_DOCUMENT,
        payload: {
            company_id,
            case_id,
            file,
        }
    };
}

export function failedInvalidateDocumentStatus() {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_INVALIDATE_DOCUMENT_STATUS,
    };
}
export function failedInvalidateDocument(company_id, case_id, file, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_INVALIDATE_DOCUMENT,
        payload: {
            company_id,
            case_id,
            file
        },
        error
    };
}

export function fetchDocumentTypes(companyId  = null) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FETCH_DOCUMENT_TYPES,
        payload : {companyId}
    };
}

export function fetchedDocumentTypes(data , companyId) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FETCHED_DOCUMENT_TYPES,
        payload: {
            data,
            companyId
        }
    };
}

export function failedFetchDocumentTypes(error) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FAILED_FETCH_DOCUMENT_TYPES,
        payload: {
            error
        }
    };
}

export function fetchApplicantsList(companyId) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FETCH_APPLICANTS_LIST,
        payload: {
            companyId
        }
    };
}

export function fetchedApplicantsList(companyId, data) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FETCHED_APPLICANT_LIST,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchApplicantsList(companyId, error) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FAILED_FETCH_APPLICANT_LIST,
        payload: {
            companyId,
            error
        }
    };
}

export function parseDocument(document, documentType) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.PARSE_DATA,
        payload: {
            document,
            documentType
        }
    };
}

export function parsedDocument(document) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.PARSED_DATA,
        payload: {
            document
        }
    };
}

export function failedParseDocument(document, error) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FAILED_PARSE_DATA,
        payload: {
            document
        },
        error
    };
}

export function requestDocuments(caseId, companyId, docs, postDocs) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.REQUEST_DOCUMENTS,
        payload: {
            caseId,
            companyId,
            docs,
            postDocs
        }
    };
}

export function requestedDocuments(caseId, companyId, docs) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.REQUESTED_DOCUMENTS,
        payload: {
            caseId,
            companyId,
            docs
        }
    };
}

export function failedRequestDocuments(caseId, companyId, error) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FAILED_REQUEST_DOCUMENTS,
        payload: {
            caseId,
            companyId,
            error
        }
    };
}

export function sendRequest(caseId) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.SEND_NOTIFICATION,
        payload: {
            caseId
        }
    };
}

export function notificationSent(caseId) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.SENT_NOTIFICATION,
        payload: {
            caseId
        }
    };
}

export function failedToSendNotification(caseId) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FAILED_SEND_NOTIFICATION,
        payload: {
            caseId
        }
    };
}

export function addRequestRemarks(company_id, case_id, file) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.ADD_REQUEST_REMARKS,
        payload: {
            company_id,
            case_id,
            file
        }
    };
}

export function addedRequestRemarks(company_id, case_id, file) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.ADDED_REQUEST_REMARKS,
        payload: {
            company_id,
            case_id,
            file,
        }
    };
}

export function failedAddRequestRemarks(company_id, case_id, file, error) {
    return {
        type: DOCUMENT_REVIEW_ACTIONS.FAILED_ADD_REQUEST_REMARKS,
        payload: {
            company_id,
            case_id,
            file
        },
        error
    };
}

export function fetchDocumentsCaseV2(case_id, company_id) {
    return {
        type: DOCUMENTS_ACTIONS.FETCH_DOCUMENTS_CASE_V2,
        payload: {
            case_id,
            company_id,
        }
    };
}
export function fetchedDocumentsCaseV2(case_id, company_id, documents) {
    return {
        type: DOCUMENTS_ACTIONS.FETCHED_DOCUMENTS_CASE_V2,
        payload: {
            case_id,
            company_id,
            documents
        }
    };
}
export function failedFetchDocumentsCaseV2(case_id, company_id, error) {
    return {
        type: DOCUMENTS_ACTIONS.FAILED_FETCH_DOCUMENTS_CASE_V2,
        payload: {
            case_id,
            company_id
        },
        error
    };
}
